import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/areaStatic',
    name: 'areaStatic',
    meta: {
      title: '分区统计',
      keepAlive: false
    },
    component: () => import('../views/areaStatic')
  },
  {
    path: '/orderInfo',
    name: 'orderInfo',
    meta: {
      title: '订单信息',
      keepAlive: false
    },
    component: () => import('../views/orderInfo')
  },
  {
    path: '/record',
    name: 'record',
    meta: {
      title: '提现记录',
      keepAlive: false
    },
    component: () => import('../views/record')
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    meta: {
      title: '用户信息',
      keepAlive: false
    },
    component: () => import('../views/userInfo')
  },
  {
    path: '/applyMoney',
    name: 'applyMoney',
    meta: {
      title: '申请提现',
      keepAlive: false
    },
    component: () => import('../views/applyMoney')
  },
  {
    path: '/totalReissue',
    name: 'areaSent',
    meta: {
      title: '整区补发',
      keepAlive: false
    },
    component: () => import('../views/areaSent')
  },
  {
    path: '/installPartition',
    name: 'installPartition',
    meta: {
      title: '安装分区',
      keepAlive: false
    },
    component: () => import('../views/installPartition')
  },
  {
    path: '/replaceRecord',
    name: 'replaceRecord',
    meta: {
      title: '补发记录',
      keepAlive: false
    },
    component: () => import('../views/replaceRecord')
  },
  {
    path: '/groupMange',
    name: 'groupMange',
    meta: {
      title: '分组管理',
      keepAlive: false
    },
    component: () => import('../views/groupMange')
  },
  {
    path: '/partitionManage',
    name: 'partitionManage',
    meta: {
      title: '分区管理',
      keepAlive: false
    },
    component: () => import('../views/partitionManage')
  },
  {
    path: '/manualReissue',
    name: 'manualReissue',
    meta: {
      title: '手动补发',
      keepAlive: false
    },
    component: () => import('../views/manualReissue')
  },
  {
    path: '/installEdit',
    name: 'installEdit',
    meta: {
      title: '编辑分区',
      keepAlive: false
    },
    component: () => import('../views/installEdit')
  },
  {
    path: '/installClone',
    name: 'installClone',
    meta: {
      title: '克隆分区',
      keepAlive: false
    },
    component: () => import('../views/installClone')
  },
  {
    path: '/accessdenied',
    name: 'accessdenied',
    meta: {
      title: '暂无权限',
      keepAlive: false
    },
    component: () => import('../views/accessdenied')
  },
  {
    path: '/callback',
    name: 'callback',
    meta: {
      title: '',
      keepAlive: false
    },
    component: () => import('../views/callback')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: '',
      keepAlive: false
    },
    component: () => import('../views/contact')
  }
];
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
